export enum EGender {
    MALE = 'M',
    FEMALE = 'F',
    NOT_BINARY = 'X'
}
